/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const name = feature.getSettingValue('SETTINGID');
    const storage = feature.getSettingValue('STORAGE');
    const dataType = feature.getSettingValue('DATATYPE');
    const STORAGE = feature.getSettingValue('STORAGE');
    const DEFAULT = feature.getSettingValue('DEFAULT', true);
    let min = feature.getSettingValue('MIN');
    if (min === '') min = feature.getDefault('MIN');
    let max = feature.getSettingValue('MAX');
    if (max === '') max = feature.getDefault('MAX');
    const project: ProjectConfiguration = feature.project;
    const SETTINGTYPE = feature.getSettingValue('SETTINGTYPE');
    const init = feature.getSettingValue('INITIALIZE');
    let defaultValue = DEFAULT;
    if (defaultValue === '') {
        defaultValue = '^';
    }
    const def: Array<string> = [DEFAULT];
    const comment = feature.getSettingValue('NAME');

    blocks.push({
        location: 'SETTINGS_XTXT',
        blockType: BlockType.CODE,
        template: `
>>${name}\t${storage}\t${dataType}\t${1}\t${min}\t${max}\t${init}\t${defaultValue}\t${comment}`,
    });

    if (STORAGE === 'R') {
        blocks.push({
            location: 'callback_stg_pre_get',
            blockType: BlockType.CODE,
            template: `if stg_name_or_num="${name}" then
    stg_value=${name}
end if`,
        });
    }

    let targetDataType = TibboDataType.STRING;
    switch (SETTINGTYPE) {
        case 'string':
            targetDataType = TibboDataType.STRING;
            break;
        case 'float':
            targetDataType = TibboDataType.FLOAT;
            break;
        case 'datetime':
            targetDataType = TibboDataType.DWORD;
            break;
        case 'time':
            targetDataType = TibboDataType.FLOAT;
            break;
        default:

            break;
    }

    blocks.push({
        location: 'callback_stg_post_set',
        blockType: BlockType.CODE,
        template: `
if stg_name_or_num="${name}" then
dim tmp_val as ${targetDataType}=${project.convertDataType('stg_value', TibboDataType.STRING, targetDataType)}
var_${name}_update_completed(tmp_val)
end if`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `${name}=${project.convertDataType(`stg_get("${name}",0)`, TibboDataType.STRING, targetDataType)}`,
    });

    return blocks;
};
